//
//
//
//
//
//
//
//
//
//

// 引入整体css样式
// import "./assets/css/style.css"
//import "./assets/scss/style.scss"

// 引入font字体图标样式 之前库
//import "./assets/fonts/icomoon.css"

// 新字体图标库
import "./assets/font/iconfont.css"
import "./assets/iconfont/iconfont.css"

//animation.css
import "animate.css"

import "@/components/common/Directive.vue"

import  {URL_ARRAY} from "./fetch/http.js";
import  http from "./fetch/http.js";
import util from '@/utils';

import {mapState, mapActions, mapGetters} from 'vuex'

export default {
  name: 'app',
    provide() {
        return {
            reload: this.reload,
        }
    },
  data() {
    return {
      URL_ARRAY:URL_ARRAY,
      loadView: false,
        isRouterAlive: true
    }
  },
  computed: {
    ...mapState({
      screenWidth: state => state.screenWidth,
      screenHeight: state => state.screenHeight,
      showLoading: state => state.status.showLoading,
    })
  },
  watch: {
    screenWidth (val) {
      this.setScreenWidth(val);
    },
    screenHeight (val) {
      this.setScreenHeight(val);
    }
  },
  methods: {
    ...mapActions({
      setScreenWidth: 'setScreenWidth',
      setScreenHeight: 'setScreenHeight',
      setUserInfo: 'setUserInfo'
    }),
      reload() {

          this.isRouterAlive = false;

          this.$nextTick(function() {


              this.isRouterAlive = true;

          })

      }
  },
  mounted () {
    window.screenWidth = document.body.clientWidth;
    window.screenHeight = document.body.clientHeight;
    this.setScreenWidth(window.screenWidth);
    this.setScreenHeight(window.screenHeight);
    let that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        window.screenHeight = document.body.clientHeight;
        that.setScreenWidth(window.screenWidth);
        that.setScreenHeight(window.screenHeight);
      })();
    }

    http.LoginAuto().then(res => {
      this.loadView = true;
      if (res.msgCode == "1") {
        if(res.data.role && res.data.role.roleCode == "student"){
          //保护用户信息
          this.setUserInfo(res.data);
          if(window.location.href.indexOf("studentMobile/home/answerstudent")>0){
            let examId = util.getUrlParam(window.location.href, "examId");
            if(!examId){
              window.location.href = window.location.origin + "/#/studentMobile/examination";
              window.location.reload();
              return;
            }
            // 重复调用接口 写到页面里 减少请求
            // http.selectExamInfo({examId: examId}).then(resInner => {
            //   // 未开始则返回列表
            //   if(!resInner.data || resInner.data.beginTime > resInner.data.nowTime){
            //     window.location.href = window.location.origin + "/#/studentMobile/examination";
            //     window.location.reload();
            //   }
            // })
          }
        }else{
          if(window.location.href.indexOf("studentMobile/home/answerstudent")>0){
            document.cookie = "ad.es.session.id=";
            this.$router.replace("/");
          }
        }
      }else{
        if(window.location.href.indexOf("mobileExamination")>0){
          window.location.href = window.location.origin + "/#/mobileExamination";
          this.$router.replace("/mobileExamination");
        }else if(window.location.href.indexOf("test")>0){
          // this.$router.replace("/test");
          this.$router.replace({path: '/test'});
        }else {
          document.cookie = "ad.es.session.id=";
          this.$router.replace("/");
        }
      }
    }, res => {
      this.loadView = true;
      document.cookie = "ad.es.session.id=";
      if(window.location.href.indexOf("test")>0){
          this.$router.replace("/test");
      }else{
        this.$router.replace("/");
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue